import { loadingButtonClasses } from "@mui/lab";
import {
    FETCH_ATTENDANCE_MONTHLY_REQUEST,
    FETCH_ATTENDANCE_MONTHLY_SUCCESS,
    FETCH_ATTENDANCE_MONTHLY_FAILURE,
} from "../constants/AttendanceDetailsConstants";

const initialState = {loading: false, data: [], error: null};

const AttendanceMonthlyReducer = (state = initialState, action) => {
    switch(action.type){
        case FETCH_ATTENDANCE_MONTHLY_REQUEST:
            return{...state, loading:true, error:null};
        case FETCH_ATTENDANCE_MONTHLY_SUCCESS:
            return{...state, loading:false, data:action.payload, error:null};
        case FETCH_ATTENDANCE_MONTHLY_FAILURE:
            return{...state, loading:false, data:[], error:action.payload};
        default:
            return state;
    }
};

export default AttendanceMonthlyReducer;